import request from './request'
const custom = 'ACTIVITY-SERVE'
// 获取大区
export function findAreaList(data) {
  return request({
    url: custom + '/department/findAreaList',
    method: 'post',
    data
  })
}

// 获取省份
// export function findProvince(data) {
//   return request({
//     url: custom + '/province/findList',
//     method: 'post',
//     data
//   })
// }

// 获取市区
// export function findCity(data) {
//   return request({
//     url: custom + '/city/findList',
//     method: 'post',
//     data
//   })
// }

// 获取市区
export function findCounty(data) {
  return request({
    url: custom + '/county/findList',
    method: 'post',
    data
  })
}
// 获取品系
export function getStrain(data) {
  return request({
    url: custom + '/strain/findList',
    method: 'post',
    data
  })
}
// 获取车系列表
export function findCarList(data) {
  return request({
    url: custom + '/market-carseries/findList',
    method: 'post',
    data
  })
}

// 获取省市区树形数据  /comm/area/all
export function getAreaTree(data) {
  return request({
    url: 'CUSTOMER-SERVE/area/getAreaTree1',
    method: 'get',
    data
  })
}

// 获取战区和大区
export function findZoneRefInfos(data) {
  return request({
    url: 'CUSTOMER-SERVE/employee/findZoneRefInfos',
    method: 'get',
    data
  })
}

// 获取经销商列表
export function findDealerList(data) {
  return request({
    url: '/ACTIVITY-SERVE/dealer/findList',
    method: 'post',
    data
  })
}

// 获取经销商列表
export function findDealerListByPage(data) {
  return request({
    url: '/ACTIVITY-SERVE/dealer/findListByPage',
    method: 'post',
    data
  })
}

// 获取大区列表
export function findSectorList(data) {
  return request({
    url: '/ACTIVITY-SERVE/dealer/findSectorList',
    method: 'get',
    data
  })
}

// 获取大区列表
export function getManagementDept4Dealer(data) {
  return request({
    url: '/ACTIVITY-SERVE/act-plan-apply/getManagementDept4Dealer',
    method: 'get',
    data
  })
}



// 获取经理部列表
export function findSectorJinLiList(data) {
  return request({
    url: '/ACTIVITY-SERVE/findSectorList',
    method: 'get',
    data
  })
}




// 获取省份
export function findProvince(data) {
  return request({
    url: '/ACTIVITY-SERVE/dealer/findProvinceList',
    method: 'get',
    data
  })
}

// 获取市区
export function findCity(data) {
  return request({
    url: '/ACTIVITY-SERVE/dealer/findCityList',
    method: 'post',
    data
  })
}

// 经销商下拉列表
export function findDlrSelectList(data) {
  return request({
    url: '/ACTIVITY-SERVE/dealer/findDlrSelectList',
    method: 'post',
    data
  })
}

// 五级来源下拉列表
export function getSourceSelectList(data) {
  return request({
    url: '/ACTIVITY-SERVE/fiveLevelSource/getSourceSelectList',
    method: 'post',
    data
  })
}

// 五级来源下拉列表
export function getCustSourceSelect(data) {
  return request({
    url: '/ACTIVITY-SERVE/fiveLevelSource/getCustSourceSelect',
    method: 'post',
    data
  })
}
